import { z } from "zod";

import {
  createStudentSchema,
  publicStudentStatusEnumSchema,
  rowStudentsTypeSchema,
} from "@libs/schemas";
import { formatStudentStatus } from "@/utils/students";

import { EnrolmentType } from "./enrolment";

export const studentSchema = rowStudentsTypeSchema;
export type StudentType = z.infer<typeof studentSchema>;

export const studentFormSchema = createStudentSchema;
export type StudentFormType = z.infer<typeof studentFormSchema>;

export const studentFilterSchema = z.object({
  search: z.string().optional().catch(""),
  statuses: z.array(publicStudentStatusEnumSchema).optional().catch([]),
  campusesIds: z.array(z.string()).optional().catch([]),
});
export type StudentFilterType = z.infer<typeof studentFilterSchema>;

export const studentSearchParamsSchema = studentFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export const studentStatusOptions = publicStudentStatusEnumSchema.options.map(
  status => ({
    label: formatStudentStatus(status),
    value: status,
  }),
);

export type StudentWithEnrolmentsType = Pick<
  StudentType,
  "id" | "first_name" | "last_name" | "created_at"
> & {
  enrolments: Pick<EnrolmentType, "id" | "campus_id" | "course">[];
};
